module.exports = __webpack_public_path__ + "img/onlineMobileSign.05a11179.jpg";